import { IProjectResourceItemsRevision } from '../../interfaces/iproject-resource-items-revision';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Item } from '../item';
import { ItemCategory } from '../item-category';
import { ItemSubCategory } from '../item-sub-category';
import { Project } from '../project';
import { ProjectEstimate } from '../project-estimate';
import { ScheduleActivity } from '../schedule-activity';
import { UnitOfMeasure } from '../unit-of-measure';

export class ProjectResourceItemsRevisionBase {
  ProjectResourceItemsRevisionId: number;
  ProjectId: number;
  ItemCategoryId: number | null;
  ResourceCalculationId: number;
  ResourceCalculationValue: string | null;
  ItemNumber: number | null;
  ItemDescription: string | null;
  EstimateDate: Date | null;
  ExtendedValue: number;
  Rate: number;
  Quantity: number;
  CostCodeCostTypeId: number | null;
  EstimateVersion: number | null;
  LastUpdatedDate: Date | null;
  LastUpdatedUser: string | null;
  IsSynced: boolean | null;
  UnitOfMeasureId: number | null;
  ItemId: number | null;
  IsManualAdd: boolean | null;
  ProjectResourceItemTypeId: number | null;
  Phase: string | null;
  Step: string | null;
  NeedByDate: Date | null;
  ScheduleActivityId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  ItemSubCategoryId: number | null;
  ProjectEstimateId: number | null;

  CostCodeCostType?: CostCodeCostType;
  ItemCategory?: ItemCategory;
  Item?: Item;
  ProjectEstimate?: ProjectEstimate;
  Project?: Project;
  ScheduleActivity?: ScheduleActivity;
  UnitOfMeasure?: UnitOfMeasure;
  ItemSubCategory?: ItemSubCategory;

  constructor(item?: IProjectResourceItemsRevision) {
    if (item) {

      this.ProjectResourceItemsRevisionId = item.ProjectResourceItemsRevisionId;
      this.ProjectId = item.ProjectId;
      this.ItemCategoryId = item.ItemCategoryId;
      this.ResourceCalculationId = item.ResourceCalculationId;
      this.ResourceCalculationValue = item.ResourceCalculationValue;
      this.ItemNumber = item.ItemNumber;
      this.ItemDescription = item.ItemDescription;
      this.EstimateDate = item.EstimateDate ? new Date(item.EstimateDate) : null;
      this.ExtendedValue = item.ExtendedValue;
      this.Rate = item.Rate;
      this.Quantity = item.Quantity;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.EstimateVersion = item.EstimateVersion;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.IsSynced = item.IsSynced;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.ItemId = item.ItemId;
      this.IsManualAdd = item.IsManualAdd;
      this.ProjectResourceItemTypeId = item.ProjectResourceItemTypeId;
      this.Phase = item.Phase;
      this.Step = item.Step;
      this.NeedByDate = item.NeedByDate ? new Date(item.NeedByDate) : null;
      this.ScheduleActivityId = item.ScheduleActivityId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.ItemSubCategoryId = item.ItemSubCategoryId;
      this.ProjectEstimateId = item.ProjectEstimateId;

      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.ItemCategory = new ItemCategory(item.ItemCategory);
      this.Item = new Item(item.Item);
      this.ProjectEstimate = new ProjectEstimate(item.ProjectEstimate);
      this.Project = new Project(item.Project);
      this.ScheduleActivity = new ScheduleActivity(item.ScheduleActivity);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
      this.ItemSubCategory = new ItemSubCategory(item.ItemSubCategory);
    }
  }
}